import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  Box,
  Typography,
  IconButton,
  Divider,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  clear_notification,
  delete_notification,
} from "redux/actions/AppActions";
import ClearIcon from "@mui/icons-material/Clear";
import { epochConverter, formatDate } from "config/helpers/date_helper";
import ClearAllRoundedIcon from "@mui/icons-material/ClearAllRounded";
import dayjs from "dayjs";
import { mappedLanguages } from "config/helpers/common_helper";

const NotificationModal = ({ open, onClose }) => {
  const app = useSelector((state) => state?.app);
  const notificationMessage = app?.notification;
  const reduxDispatch = useDispatch();

  const { i18n } = useTranslation();
  const message = i18n.t("notifications.MESSAGE");
  const handleClearAllNotifications = () => {
    reduxDispatch(clear_notification());
  };
  const handleDeleteNotification = (data) => {
    reduxDispatch(delete_notification(data));
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          position: "fixed",
          top: "64px",
          right: "2rem",
        }}
        className="notification-height"
      >
        <Paper
          // className={`bg-${app.theme}`}
          sx={{ width: "300px", MinHeight: "200px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle sx={{ paddingLeft: "14px" }}>
              {i18n.t("notifications.NOTIFICATION")}
            </DialogTitle>
            <Tooltip
              enterTouchDelay={0}
              disableInteractive
              placement="left"
              title={i18n.t("common.CLEAR_ALL")}
            >
              <IconButton
                sx={{
                  height: "50px",
                  width: "50px",
                  borderRadius: "50%",
                  marginRight: "10px",
                }}
                onClick={handleClearAllNotifications}
              >
                <ClearAllRoundedIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box
            sx={{
              maxHeight: "40vh",
              overflowY:
                notificationMessage && notificationMessage.length > 0
                  ? "scroll"
                  : "hidden",
              overflowX: "visible",
            }}
          >
            {notificationMessage?.length ? (
              notificationMessage?.map((notification) => {
                return (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "2px 10px",
                        margin: "4px",
                        background: !notification?.isRead
                          ? app?.theme == "light"
                            ? "#dfe9f5"
                            : app?.theme == "dark" && "#5c5d5e"
                          : "inherit",
                        borderRadius: "5px",
                      }}
                    >
                      <Typography
                        fontSize={14}
                        sx={{
                          fontFamily: "Poppins",
                          fontWeight: "500",
                        }}
                      >
                        {notification?.message}
                        <Typography
                          fontSize={10}
                          sx={{
                            fontFamily: "Poppins",
                            fontWeight: "400",
                          }}
                        >
                          {/* <i> */}
                          {dayjs(epochConverter(notification?.addedOn)).format(mappedLanguages?.[i18n?.language]?.timeWithDateFormat)}
                          {/* </i> */}
                        </Typography>
                      </Typography>
                      <IconButton
                        onClick={() =>
                          handleDeleteNotification(notification?.addedOn)
                        }
                      >
                        <ClearIcon />
                      </IconButton>
                    </Box>
                    <Divider variant="middle" />
                  </>
                );
              })
            ) : (
              <DialogContent
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: "500",
                }}
              >
                {i18n.t("notifications.NO_NOTIFICATIONS_RIGHT_NOW")}
              </DialogContent>
            )}
          </Box>
          <DialogActions>
            <Button onClick={onClose} color="primary">
              {i18n.t("notifications.CLOSE")}
            </Button>
          </DialogActions>
        </Paper>
      </Box>
    </Dialog>
  );
};

export default NotificationModal;
